export const calculateEtaForSku = (saId, saList = []) => {
  const saInfoForSKU = saList.find((sa) => Number(sa.sa_id) === Number(saId));
  const validEtaRegex = /\d/;
  if (!saInfoForSKU || !validEtaRegex.test(saInfoForSKU.eta)) {
    return null;
  }
  return saInfoForSKU.eta;
};
